import { createStore } from "vuex";
import auth from "@/store/modules/auth";
import preloader from "@/store/modules/preloader";
import errorsModal from "@/store/modules/modals/errorsModal";
import userManagement from "@/store/modules/settings/userManagement";
import successFeedback from "./modules/modals/successFeedback";
import financialControl from "./modules/financialControl";
import orders from "./modules/orders/orders";
import customers from "./modules/customers/customers";
import emailLogs from "./modules/settings/emailLogs";
import salesByDealers from "@/store/modules/reports/salesByDealers";
import salesByProducts from "@/store/modules/reports/salesByProducts";
import orderDetails from "@/store/modules/orders/orderDetails";
import productionDashboard from "@/store/modules/productionDashboard/productionDashboard";

// Create a new store instance.
const store = createStore({
  modules: {
    auth,
    preloader,
    errorsModal,
    userManagement,
    successFeedback,
    financialControl,
    orders,
    customers,
    emailLogs,
    salesByDealers,
    salesByProducts,
    orderDetails,
    productionDashboard,
  },
});

export default store;
